// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"611":"a73d7f58","661":"1d8929ba","787":"0624c8db"}[chunkId] + ".chunk.js";
};